import React, { useState } from 'react';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';
import { ModalDialogProps } from '@eika/modal';

import { useSession } from '@components/app/Session';
import { useNavigate } from '@domain/app';
import { isOwnerOfCard } from '@domain/card/service';
import { GooglePayTeData, useGoogleWalletSigningMutation } from '@domain/digital-wallet';
import useText from '@hooks/use-text';
import EikaModal from '@utils/modal/EikaModal';

import Footer from './Footer';
import PermissionInformation from './PermissionInformation';
import { handleEndGTPWalletProcess } from './permission-signing/functions';

import './PermissionConfirmModal.scss';

interface PermissionConfirmModalProps extends ModalDialogProps {
    data: GooglePayTeData;
    googleWalletInfo: GtpWalletInfoResult;
}

const PermissionConfirmModal = ({ data, setOpen, googleWalletInfo, ...rest }: PermissionConfirmModalProps) => {
    const googleSigning = useGoogleWalletSigningMutation({ card: data.card });
    const { googleWalletConfirmAddPermissionToGooglePayHeader } = useText();
    const navigate = useNavigate();
    const session = useSession();

    const [permissionGiven, setPermissionGiven] = useState<boolean>(false);
    const [pushProvisionSuccess, setPushProvisionSuccess] = useState<boolean>(false);

    const onConfirmGooglePayActivationSigning = () => {
        if (!isOwnerOfCard(data.card, session)) {
            return;
        }

        googleSigning.mutate();
    };

    const confirmPermission = () => {
        setPermissionGiven(true);
        onConfirmGooglePayActivationSigning();
    };

    const handlePushProvisionSuccess = () => {
        setPushProvisionSuccess(true);
        handleEndGTPWalletProcess(data.card, navigate);
    };

    const close = () => {
        setPermissionGiven(false);
        googleSigning.reset();
        setOpen(false);
    };

    return (
        <EikaModal
            setOpen={close}
            title={googleWalletConfirmAddPermissionToGooglePayHeader}
            footerContent={
                <Footer
                    permissionGiven={permissionGiven}
                    pushProvisionSuccess={pushProvisionSuccess}
                    confirmPermission={confirmPermission}
                    close={close}
                />
            }
            {...rest}
        >
            <PermissionInformation
                data={data}
                permissionGiven={permissionGiven}
                handlePushProvisionSuccess={handlePushProvisionSuccess}
                pushProvisionSuccess={pushProvisionSuccess}
                signResponse={googleSigning.data}
                googleWalletInfo={googleWalletInfo}
            />
        </EikaModal>
    );
};

export default PermissionConfirmModal;
